<template>
  <v-card class="secondary" height="100%">
    <v-form ref="form">
      <v-card-title class="font-weight-medium secondary--text primary">
        Exam Paper Details
        <v-spacer></v-spacer>
        <v-btn small icon @click="$emit('closeDialog')">
          <v-icon small color="secondary">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-list two-line>
          <v-list-item
            v-for="course in studentExamPapers"
            :key="course.id"
            class="mb-2"
          >
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                {{ course.course_name }}
              </v-list-item-title>
              <v-list-item-subtitle>
                <strong>Code:</strong> {{ course.course_code }} |
                <strong>Credits:</strong> {{ course.credits }} |
                <strong>Exam Date:</strong> {{ course.exam_date }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-form>
  </v-card>
</template>
<script>
export default {
  props: {
    studentExamPapers: {
      type: Array,
      default: () => [],
    },
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {},
};
</script>

<style scoped></style>
